/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Expense_Category_Used_By_RuleInputs */

const vi_error_expense_category_used_by_rule = /** @type {(inputs: Error_Expense_Category_Used_By_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục đang được quy tắc tự phân loại sử dụng. Đổi hoặc xoá các quy tắc đó trước.`)
};

/**

* @param {Error_Expense_Category_Used_By_RuleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_expense_category_used_by_rule = /** @type {((inputs?: Error_Expense_Category_Used_By_RuleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Expense_Category_Used_By_RuleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_expense_category_used_by_rule(inputs)
});